export interface BeTarefa {
  id?: number;
  idUsuario: number;
  noQuadro: string;
  dsQuadro?: string | null;
  noCor?: string | null;
  nrOrdem: number;
  blArquivado: boolean;
  dtCriacao: string;
  dtAlteracao: string;
}

export interface BeTarefaColuna {
  id?: number;
  idTarefa: number;
  noColuna: string;
  nrOrdem: number;
  noCor?: string | null;
  blFinalizadora: boolean;
  blArquivado: boolean;
  cartoes: BeTarefaCartao[];
}

export interface BeTarefaCartao {
  id?: number;
  idTarefaColuna: number;
  noCartao: string;
  dsCartao?: string | null;
  noPrioridade?: string | null;
  dtVencimento?: string | null;
  nrOrdem: number;
  blArquivado: boolean;
  idsEtiquetas: number[];
  etiquetas: BeTarefaEtiqueta[];
  checklists: BeTarefaChecklist[];
  historicos: BeTarefaHistorico[];
  comentarios: BeTarefaComentario[];
}

export interface BeTarefaEtiqueta {
  id?: number;
  idUsuario: number;
  noEtiqueta: string;
  noCor: string;
}

export interface BeTarefaChecklist {
  id?: number;
  idTarefaCartao: number;
  dsItem: string;
  nrOrdem: number;
  blConcluido: boolean;
  dtConclusao?: string | null;
}

export interface BeTarefaHistorico {
  id?: number;
  noEvento: string;
  dsEvento: string;
  dtEvento: string;
}

export interface BeTarefaComentario {
  id?: number;
  idTarefaCartao: number;
  idUsuario: number;
  dsComentario: string;
  dtCriacao: string;
  noNomeUsuario?: string | null;
}

export interface BeTarefaQuadro {
  tarefa: BeTarefa;
  colunas: BeTarefaColuna[];
}
